import Vue from 'vue'
import '@/assets/style'
import App from './App.vue'

import './plugins'

// ACL
// import acl from './plugins/acl/acl'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n'

Vue.config.productionTip = false

// debug
window.$s = store

window.vuevm = new Vue({
  router,
  store,
  i18n,
  // acl,
  render: h => h(App)
}).$mount('#app')
